<template>
  <div class="component-uploader-file fs-16 color-17181A" :class="computedClass">
    <div class="upload-ready-wrap uploader-wrap" v-show="state === STATE.READY">
      <input :accept="acceptTypeStr" ref="file" type="file" class="_uploader" v-show="!disabled" @change="handleFileChange" />
      <div class="loader-content">
        <div class="i-upload i-icon"></div>
        <span class="w-bold upload-text">{{ text }}</span>
      </div>
    </div>
    <div class="upload-load-wrap uploader-wrap" v-show="state === STATE.LOAD">
      <div class="loader-content">
        <div class="c-loader"></div>
        <span class="w-normal upload-text">{{ loadText }}</span>
      </div>
    </div>
    <div class="upload-success-wrap uploader-wrap" v-show="state === STATE.SUCCESS">
      <div class="loader-content">
        <Tick width="20px" className="i-icon" />
        <span class="w-normal upload-text">{{ fileName }}</span>
      </div>
      <Close width="20px" className="i-close i-icon" color="#494A4D" @click="showReady" />
    </div>
    <div class="upload-error-wrap uploader-wrap" v-show="state === STATE.ERROR">
      <!-- <input :accept="acceptTypeStr" ref="file" type="file" class="_uploader" v-show="!disabled" @change="handleFileChange" /> -->
      <div class="loader-content">
        <Close class="i-icon" width="20px" color="#E61717" />
        <span class="w-normal upload-text">{{ errMsg }}</span>
      </div>
      <div class="i-reverse i-icon" @click="showReady"></div>
    </div>
    <div class="upload-msg fs-12" :class="msgClass" v-html="msg"></div>
  </div>
</template>
<script>
import UTILS from '../utils';
import UPLOAD_TYPE from '../uploadType';
import ROLES from '../../../../utils/roles';
import { Tick, Close } from '../../../icons';
import { Codes } from '../../../../api';
const STATE = {
  READY: 'READY',
  LOAD: 'LOAD',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
/**
 * 文件上传组件
 * @module FileUploader
 */
export default {
  name: 'FileUploader',
  /**
   * @prop {Component} Tick 打勾图标
   * @prop {Component} Close 打岔图标
   */
  components: {
    Tick,
    Close
  },
  /**
   * @prop {Number} maxSize 最大大小
   * @prop {String} sizeType 尺寸类型 默认mb
   * @prop {String} type 上传文件类型
   * @prop {String} className 外部class
   * @prop {Array} acceptType 支持文件类型 'MP4' 'MOV' 'AVI' 具体 查acceptTypes.js
   * @prop {String} size 组件大小 默认normal
   * @prop {String} loadText 上传中组件文字 默认上传中...
   * @prop {String} text 组件准备状态时内容 默认上传文件
   * @prop {Boolean} disabled 是否禁用状态
   * @prop {Object} value 数据
   * @prop {Boolean} showMsg 展示提示信息
   * @prop {String} msg 提示信息
   * @prop {String} msgState 信息类型 normal/error 默认normal
   * @prop {String} role 组件使用者类型 默认student
   * @prop {String} filename 自定义上传的文件名
   */
  props: {
    maxSize: {
      type: Number,
      default: 0
    },
    sizeType: {
      type: String,
      default: 'mb'
    },
    type: {
      type: String,
      default: UPLOAD_TYPE.FILE
    },
    className: {
      type: String,
      default: ''
    },
    acceptType: {
      type: Array,
      default: function() {
        return [];
      }
    },
    size: {
      type: String,
      default: 'normal'
    },
    loadText: {
      type: String,
      default: '上传中...'
    },
    text: {
      type: String,
      default: '上传文件'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: function() {
        return {};
      }
    },
    showMsg: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: '提示文字'
    },
    msgState: {
      type: String,
      default: 'normal'
    },
    id: {
      default: ''
    },
    method: {
      type: String,
      default: 'oss'
    },
    role: {
      type: String,
      default: ROLES.STUDENT
    },
    filename: {
      type: String,
      default: ''
    },
    rename: {
      type: Boolean,
      default: false
    },
    resetKey: {
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 计算后的组件class
   * @prop {String} acceptTypeStr 传入input具体accept
   * @prop {Object} STATE 组件所有状态
   */
  computed: {
    msgClass() {
      let ret = {};
      ret[`type-${this.msgState}`] = true;
      ret['show'] = this.showMsg;
      return ret;
    },
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret[`size-${this.size}`] = true;
      ret['disabled'] = this.disabled;
      return ret;
    },
    acceptTypeStr() {
      return UTILS.getAcceptTypeStr(this.acceptType);
    },
    STATE() {
      return STATE;
    },
    fileName() {
      let ret = '';
      if (this.value && this.value.name) {
        ret = this.value.name;
      }
      return ret;
    }
  },
  watch: {
    value(val) {
      // console.log(this.value, this.value.name);
      if (this.value && this.value.name) {
        this.state = STATE.SUCCESS;
      }
    },
    state(state) {
      switch (state) {
        case STATE.READY:
          this.$emit('ready');
          break;
        case STATE.LOAD:
          this.$emit('load');
          break;
        case STATE.SUCCESS:
          this.$emit('success');
          break;
      }
    }
  },
  /**
   * @prop {String} state 组件状态
   * @prop {String} errMsg 错误文字
   * @prop {String} file 文件
   */
  data: () => ({
    state: STATE.READY,
    errMsg: '上传失败 请重新上传',
    file: null
  }),
  created: function() {
    if (this.value && this.value.name) {
      this.state = STATE.SUCCESS;
    } else {
      this.showReady();
    }
  },
  mounted() {},
  methods: {
    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 文件变化事件
     * @function handleFileChange
     */
    handleFileChange: async function(e) {
      if (e.target.files && e.target.files.length) {
        this.file = e.target.files[0];
        this.state = STATE.LOAD;
        if (this.method === 'oss') {
          let file_name = '';
          if (this.filename) {
            const idx = this.file.name.lastIndexOf('.');
            const len = this.file.name.length;
            const suffixName = this.file.name.substring(idx, len);
            file_name = this.filename + suffixName;
          } else {
            file_name = this.file.name;
          }
          let res = await UTILS.uploadFile(this.file, this.type, this.maxSize, this.sizeType, this.role, file_name, this.rename, this.resetKey);
          if (res.status === Codes.SUCCESS) {
            this.state = STATE.SUCCESS;
            this.$emit(
              'input',
              {
                name: file_name,
                url: res.data.url
              },
              this.id
            );
          } else {
            this.showErr(res.msg);
          }
        } else {
          this.state = STATE.SUCCESS;
          this.$emit('input', this.file, this.id);
        }
      }
    },
    /**
     * @event input v-model绑定事件
     */
    /**
     * @description 切换为准备状态
     * @function showReady
     */
    showReady: function() {
      this.$emit('input', {}, this.id);
      this.file = null;
      if (this.$refs.file) {
        this.$refs.file.value = '';
      }
      this.state = STATE.READY;
    },
    /**
     * @event error 错误钩子
     */
    /**
     * @description 切换为错误状态
     * @function showErr
     * @param {String} msg 错误信息
     */
    showErr: function(msg) {
      this.state = STATE.ERROR;
      this.errMsg = msg;
      this.$emit('error', msg, this.id);
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
